import { render, staticRenderFns } from "./Crew.vue?vue&type=template&id=1cc472b2"
import script from "./Crew.vue?vue&type=script&lang=js"
export * from "./Crew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Crew.vue
// module id = 1737
// module chunks = 31